import type { FC } from 'react';
import { Button } from 'src/common/components/button';
import { isFlowUsApp } from 'src/utils/electron-util';
import { useGetPageId } from 'src/utils/getPageId';
import { setLocalStorage } from 'src/utils/local-storage';
import { getLocationOrigin, locationToUrl } from 'src/utils/location-utils';
import { useTryPage } from 'src/views/main/aside/toc/use-try-page';
import { Placeholder } from './placeholder';

/** 前往share */
export const ToSharedPage: FC<{}> = () => {
  const tryPageId = useTryPage();
  const pageId = useGetPageId();
  const hashPath = location.hash;
  const url = `${getLocationOrigin()}/share/${pageId}${hashPath}`;

  return (
    <Placeholder icon="🤔" title="页面已开启分享" description="点击下方链接访问">
      <a className="text-t1" href={url}>
        {url}
      </a>
      {isFlowUsApp.check && (
        <Button
          className="mx-auto mt-5"
          onClick={() => {
            setLocalStorage('tryPageId', tryPageId);
            locationToUrl(`/${tryPageId}`);
          }}
        >
          返回主页
        </Button>
      )}
    </Placeholder>
  );
};
